
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 5.153c.363 0 .669.121.927.369.258.247.39.564.39.948 0 .553-.263.954-.79 1.201v4.594H6.973V7.67c-.527-.247-.79-.648-.79-1.2 0-.385.137-.702.39-.95.253-.247.564-.368.927-.368m2.47-1.159c.66.659 1.012 1.48 1.06 2.476 0 .948-.353 1.78-1.06 2.487l-.626-.643c.527-.48.79-1.096.79-1.844 0-.7-.263-1.317-.79-1.844l.627-.632m-5.584-.643c-.838.838-1.26 1.876-1.26 3.12 0 1.242.422 2.264 1.26 3.102l-.617.643C2.76 9.146 2.232 7.892 2.232 6.47s.527-2.666 1.538-3.735l.617.616m6.843-.616c1.011 1.07 1.538 2.313 1.538 3.735 0 1.475-.527 2.724-1.538 3.746l-.617-.643c.838-.838 1.26-1.875 1.26-3.103s-.422-2.281-1.26-3.119l.617-.616m-6.2 1.26l.626.631c-.527.485-.79 1.096-.79 1.844 0 .7.263 1.317.79 1.844l-.627.643C4.323 8.25 3.97 7.418 3.97 6.47c0-.948.353-1.77 1.06-2.476z"}})])
          )
        }
      }
    